import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import styles from "./layout.module.scss"
import Nav from "../nav"
import Footer from "../footer"
import { cn } from "../../lib/helpers"

const Layout = ({
  children,
  noPadding,
  className,
  transparentPos,
  isHomePage,
}) => {
  const { sanitySettings, sanityNavigation } = useStaticQuery(graphql`
    query {
      sanityNavigation(_id: { regex: "/navigation$/" }) {
        links {
          ... on SanityLink {
            _type
            name
            href
          }
          ... on SanityPage {
            _type
            title
            slug {
              current
            }
          }
        }
      }
      sanitySettings(_id: { eq: "settings" }) {
        siteName
        logo {
          ...ImageWithPreview
        }
      }
    }
  `)

  const { siteName, logo } = sanitySettings
  const { links } = sanityNavigation

  return (
    <div className={styles.pageWrapper}>
      <Nav
        logo={logo}
        siteTitle={siteName}
        navigationLinks={links}
        transparentPos={transparentPos}
        isHomePage={isHomePage}
      />
      <main
        className={cn(noPadding && styles.noPadding, styles.layout, className)}
      >
        {children}
      </main>
      <Footer siteName={siteName} navigationLinks={links} />
    </div>
  )
}

Layout.defaultProps = {
  noPadding: false,
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
  className: PropTypes.string,
}

export default Layout
